import React from 'react';
import Layout from '../../Components/Common/Layout';
import ContactUs from '../../Components/ContactUs';

const ContactUsPage: React.FC = () => {
  return (
    <Layout title={'contactUs'}>
      <ContactUs />
    </Layout>
  );
};

export default ContactUsPage;
